import { render, staticRenderFns } from "./NavApp.vue?vue&type=template&id=4b5a72c6&scoped=true&"
import script from "./NavApp.vue?vue&type=script&lang=js&"
export * from "./NavApp.vue?vue&type=script&lang=js&"
import style0 from "./NavApp.vue?vue&type=style&index=0&id=4b5a72c6&lang=scss&scoped=true&"
import style1 from "./NavApp.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b5a72c6",
  null
  
)

export default component.exports